import React, { useState } from "react";
// import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import Select from "react-select";

const Group = () => {
  const [showModal, setShowModal] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  // Example employees list (this can come from backend API later)
  const employees = [
    { value: "1", label: "Devrath Rana" },
    { value: "2", label: "Nivea Sharma" },
    { value: "3", label: "Yash Timberlake" },
    { value: "4", label: "Prashant Mahasagar" },
    { value: "5", label: "Pewsh Halkat" },
    { value: "6", label: "Humaira Aapa" },
    { value: "7", label: "Naved Khanna" },
  ];

  const handleCreateGroup = () => {
    console.log("Group Name:", groupName);
    console.log("Selected Employees:", selectedEmployees);

    // TODO: Call API here to save group
    setShowModal(false);
    setGroupName("");
    setSelectedEmployees([]);
  };

  return (
    <div>
      <Container className="p-4">
        <Row className="mb-4">
          <Col>
            <h2 className="fw-bold">Admin Dashboard</h2>
            <p className="text-muted">Manage groups, tasks, and users here.</p>
          </Col>
        </Row>

        <Row>
          {/* Create Group Box */}
          <Col md={4}>
            <Card className="shadow-sm border-0">
              <Card.Body className="text-center">
                <Card.Title>Create Group</Card.Title>
                <Card.Text>Organize members by creating a new group.</Card.Text>
                <Button variant="primary" onClick={() => setShowModal(true)}>
                  + Create Group
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Create Group Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Create New Group</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Group Name */}
              <Form.Group className="mb-3">
                <Form.Label>Group Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter group name"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                />
              </Form.Group>

              {/* Employee Multi-Select */}
              <Form.Group>
                <Form.Label>Add Employees</Form.Label>
                <Select
                  isMulti
                  options={employees}
                  value={selectedEmployees}
                  onChange={setSelectedEmployees}
                  placeholder="Search & select employees..."
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleCreateGroup}>
              Create Group
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default Group;
